var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatBubbles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "chat_bubbles",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M22,21.2l0.4,2.5c0,0.3-0.2,0.4-0.5,0.3l-2.5-1.3c-0.6,0.2-1.2,0.3-1.9,0.3c-3.6,0-6.4-2.8-6.5-6.4  c0,0,0-0.1,0-0.1c0-3.4,2.6-6.2,5.9-6.5c0.2,0,0.4,0,0.6,0c3.6,0,6.5,2.9,6.5,6.5C24,18.3,23.2,20,22,21.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M17,8.5c0,0.5,0,1-0.1,1.5c-3.3,0.3-5.9,3.1-5.9,6.5c0,0,0,0.1,0,0.1C10.2,16.9,9.4,17,8.5,17  c-0.9,0-1.8-0.2-2.7-0.4l-3.4,1.7c-0.3,0.2-0.7-0.1-0.6-0.5l0.6-3.4C0.9,12.8,0,10.8,0,8.5C0,3.8,3.8,0,8.5,0S17,3.8,17,8.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbles);
export default __webpack_public_path__ + "static/media/chat_bubbles.fd2aa8ce.svg";
export { ForwardRef as ReactComponent };